export const WEBTEXT_FREE_SITES = ["error", "wip", "storage-alert"];
